import React, { useState } from 'react';
import AdUnit from './AdSense';

const AdGatedFeatures = ({ onFeatureSelect, userType }) => {
  const [showAd, setShowAd] = useState(false);
  const [selectedFeatures, setSelectedFeatures] = useState({
    imageGeneration: false,
    dreamInterpretation: false
  });
  const [adWatched, setAdWatched] = useState({
    imageGeneration: false,
    dreamInterpretation: false
  });
  const [currentFeature, setCurrentFeature] = useState(null);

  const handleFeatureToggle = (feature) => {
    if (userType !== 'simple') {
      // Pro and admin users can toggle features directly
      const newFeatures = {
        ...selectedFeatures,
        [feature]: !selectedFeatures[feature]
      };
      setSelectedFeatures(newFeatures);
      onFeatureSelect(newFeatures);
      return;
    }

    // For simple users, show ad if not already watched
    if (!adWatched[feature]) {
      setCurrentFeature(feature);
      setShowAd(true);
      const newFeatures = {
        ...selectedFeatures,
        [feature]: !selectedFeatures[feature]
      };
      setSelectedFeatures(newFeatures);
    } else {
      // If ad already watched, allow toggle directly
      const newFeatures = {
        ...selectedFeatures,
        [feature]: !selectedFeatures[feature]
      };
      setSelectedFeatures(newFeatures);
      onFeatureSelect(newFeatures);
    }
  };

  const handleAdLoad = () => {
    console.log('Ad loaded');
  };

  const handleAdClosed = () => {
    setAdWatched(prev => ({
      ...prev,
      [currentFeature]: true
    }));
    setShowAd(false);
    onFeatureSelect(selectedFeatures);
    setCurrentFeature(null);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-col space-y-2">
        {/* <label className="inline-flex items-center">
          <input
            type="checkbox"
            className="form-checkbox text-purple-500"
            checked={selectedFeatures.imageGeneration}
            onChange={() => handleFeatureToggle('imageGeneration')}
          />
          <span className="ml-2 text-gray-300">Generate Image</span>
        </label> */}
        {/* <label className="inline-flex items-center">
          <input
            type="checkbox"
            className="form-checkbox text-purple-500"
            checked={selectedFeatures.dreamInterpretation}
            onChange={() => handleFeatureToggle('dreamInterpretation')}
          />
          <span className="ml-2 text-gray-300">Dream Interpretation</span>
        </label> */}
      </div>

      {showAd && userType === 'simple' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl max-w-md w-full">
            <h3 className="text-xl font-semibold text-white mb-4">
              Watch Ad to Enable {currentFeature === 'imageGeneration' ? 'Image Generation' : 'Dream Interpretation'}
            </h3>
            <AdUnit 
              adSlot="6045190321"
              onAdLoaded={handleAdLoad}
              onAdClosed={handleAdClosed}
            />
            <button
              className="mt-4 w-full py-2 bg-purple-500 text-white rounded-full hover:bg-purple-600 transition-colors"
              onClick={handleAdClosed}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdGatedFeatures;
